// src/components/Testimonials.js

function Testimonials() {
  return (
    <section className="founding-section">

      <div className="founding-container">

        {/* Badge */}
        <div className="founding-badge">
          🚀 Founding Batch – 2026
        </div>

        {/* Heading */}
        <h2>
          Become a Founding Learner 🚀
        </h2>

        {/* Subtext */}
        <p className="founding-subtext">
          Join our first batch and help shape the future of CODEION.
          Get personalized attention, early access benefits, and direct mentorship.
        </p>

        {/* Points */}
        <div className="founding-points">

          <div className="founding-point">
            ✅ Limited seats for focused learning
          </div>

          <div className="founding-point">
            ✅ Direct interaction with mentors
          </div>

          <div className="founding-point">
            ✅ Early learner benefits (discounts / bonuses)
          </div>

          <div className="founding-point">
            ✅ Opportunity to influence course structure
          </div>

          <div className="founding-point">
            ✅ Certificate for founding batch members
          </div>

        </div>

      </div>

    </section>
  );
}

export default Testimonials;